var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.9998C9.65481 19.9998 9.375 19.72 9.375 19.3748V16.8748C9.375 16.5296 9.65481 16.2498 10 16.2498C10.3452 16.2498 10.625 16.5296 10.625 16.8748V19.3748C10.625 19.72 10.3452 19.9998 10 19.9998Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 9.99982C4.375 13.1064 6.89337 15.6248 10 15.6248C13.1066 15.6248 15.625 13.1064 15.625 9.99982C15.625 6.89319 13.1066 4.37482 10 4.37482C6.89337 4.37482 4.375 6.89319 4.375 9.99982ZM10 14.3748C7.58375 14.3748 5.625 12.4161 5.625 9.99982C5.625 7.58357 7.58375 5.62482 10 5.62482C12.4163 5.62482 14.375 7.58357 14.375 9.99982C14.375 12.4161 12.4163 14.3748 10 14.3748Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 10.6248C19.7202 10.6248 20 10.345 20 9.99979C20 9.6546 19.7202 9.37479 19.375 9.37479H16.875C16.5298 9.37479 16.25 9.6546 16.25 9.99979C16.25 10.345 16.5298 10.6248 16.875 10.6248H19.375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 10.6248C3.47018 10.6248 3.75 10.345 3.75 9.99979C3.75 9.6546 3.47018 9.37479 3.125 9.37479H0.625C0.279822 9.37479 0 9.6546 0 9.99979C0 10.345 0.279822 10.6248 0.625 10.6248H3.125Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.071 17.0706C16.827 17.3147 16.4312 17.3147 16.1872 17.0706L14.4194 15.3029C14.1753 15.0588 14.1753 14.6631 14.4194 14.419C14.6635 14.1749 15.0592 14.1749 15.3033 14.419L17.071 16.1868C17.3151 16.4308 17.3151 16.8266 17.071 17.0706Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58032 5.58021C5.33623 5.82434 4.94051 5.82434 4.69643 5.58021L2.92867 3.81246C2.68459 3.5684 2.68459 3.17265 2.92867 2.92858C3.17274 2.68452 3.56847 2.68452 3.81255 2.92858L5.58032 4.69634C5.82439 4.94046 5.82439 5.33615 5.58032 5.58021Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92867 17.0706C2.68459 16.8266 2.68459 16.4308 2.92867 16.1868L4.69643 14.419C4.94051 14.1749 5.33623 14.1749 5.58032 14.419C5.82439 14.6631 5.82439 15.0588 5.58032 15.3029L3.81255 17.0706C3.56847 17.3147 3.17274 17.3147 2.92867 17.0706Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4194 5.58021C14.1753 5.33615 14.1753 4.94046 14.4194 4.69634L16.1872 2.92858C16.4312 2.68452 16.827 2.68452 17.071 2.92858C17.3151 3.17265 17.3151 3.5684 17.071 3.81246L15.3033 5.58021C15.0592 5.82434 14.6635 5.82434 14.4194 5.58021Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.12479C9.375 3.46997 9.65481 3.74979 10 3.74979C10.3452 3.74979 10.625 3.46997 10.625 3.12479V0.62479C10.625 0.279603 10.3452 -0.000209808 10 -0.000209808C9.65481 -0.000209808 9.375 0.279603 9.375 0.62479V3.12479Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.f3fcc395.svg";
export { ForwardRef as ReactComponent };